// extracted by mini-css-extract-plugin
export var article = "Article-module--article--ee204";
export var content = "Article-module--content--b7138";
export var header = "Article-module--header--baf65";
export var info = "Article-module--info--aa8cf";
export var keyword = "Article-module--keyword--4f8ca";
export var keywords = "Article-module--keywords--f863e";
export var keywordsTitle = "Article-module--keywords-title--1164a";
export var newsletterForm = "Article-module--newsletter-form--07220";
export var services = "Article-module--services--46b3b";
export var shareButtons = "Article-module--share-buttons--24d39";
export var title = "Article-module--title--39a7a";
export var wrapper = "Article-module--wrapper--0b9d3";